import i18next from 'i18next'
import {TransactionDirection, TransactionStatus} from '@/stores'
import {SelectItem} from '@/components/dumb/Select'
export const getDebitCreditAmount = (amount: number, type: TransactionDirection): number => {
    switch (type) {
        case 'credit':
            return amount * -1
        default:
            return amount
    }
}

export const getStatusSelectOptions = (): SelectItem[] => {
    return [
        {
            label: i18next.t('AccountInfo.all'),
            value: ''
        },
        ...Object.keys(TransactionStatus).map(key => ({
            label: i18next.t(`AccountInfo.transactionStatus.${key}`),
            value: TransactionStatus[key]
        }))
    ]
}
